//
// Tab Control by Link Url(JS)
// 2020-05-28
// Yusuke Manabe @ Space-Time Inc.
//


(function() {

	const hash = location.hash;
	window.addEventListener('load', function() {
		if (hash.indexOf('#tab:') === 0) {
			const id = hash.slice(1);
			const tabElement = document.querySelector('li[data-id=\'' + id + '\']');
			if (tabElement === null) return;
			setTimeout(function() {
				tabElement.click();
				tabElement.blur();
			}, 100);
		}
	});

}());
